var _rect, _circle, _circle2, _path, _circle3, _circle4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeafood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    rx: 30,
    fill: "#5C6CFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 177.5,
    cy: 98.9286,
    r: 37.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.5,
    cy: 98.9286,
    r: 14.6429,
    fill: "#030303"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.5 61.4286C198.211 61.4286 215 78.2179 215 98.9286C215 99.0479 214.996 99.167 214.995 99.286H140.005C140.004 99.167 140 99.0479 140 98.9286C140 78.2179 156.789 61.4286 177.5 61.4286Z",
    fill: "#E4E4E4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.6429,
    cy: 98.9286,
    r: 37.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.6429,
    cy: 98.9286,
    r: 14.6429,
    fill: "#030303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121 169.41C127.833 166.576 142.2 163.91 145 175.91C147.8 187.91 131.5 187.243 123 185.41C130.667 186.243 145.2 189.11 142 193.91C138.8 198.71 126.667 199.243 121 198.91",
    stroke: "#06138B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeafood);
export default __webpack_public_path__ + "static/media/Seafood.19a2a1cc9f1d289144988f4e04aeb875.svg";
export { ForwardRef as ReactComponent };